module.exports = __webpack_public_path__ + "static/media/our-coaches-7.66123bda.jpg";